// extracted by mini-css-extract-plugin
export default {"table":"table_table__2IQ7e","tableHeader":"table_tableHeader__2v2ht","imgRow":"table_imgRow__4IaXz","rowData":"table_rowData__P3W8I","songImg":"table_songImg__BUiH6"};